import { css } from "@emotion/css";
import { $, type Properties, resolve } from "signlets";

import { CheckboxCheckedIcon } from "./icons/CheckboxCheckedIcon";
import { CheckboxIcon } from "./icons/CheckboxIcon";

const style = css`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;

  > input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }

  > .icon {
    width: 1.5rem;
    height: 1.5rem;
    flex: 0 0 auto;
    color: currentColor;

    > svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
`;

export type CheckboxProps = {
  value: boolean;
  onChange: (_: boolean) => void;
  children?: JSX.Element;
};

export const Checkbox = ({
  value,
  onChange,
  children,
}: Properties<CheckboxProps>) => {
  const onInput = ({
    currentTarget,
  }: Event & { currentTarget: HTMLInputElement }) => {
    const value = currentTarget.checked;
    onChange(value);
  };

  return (
    <label class={style}>
      <input type="checkbox" checked={value} onInput={onInput} />
      <span class="icon" aria-hidden="true">
        {$(() => (resolve(value) ? <CheckboxCheckedIcon /> : <CheckboxIcon />))}
      </span>
      {children}
    </label>
  );
};
